// extracted by mini-css-extract-plugin
module.exports = {"root":"Toggler_root__3VEnE"};